import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { RfPolarizationState } from "../../models/mp-common/rf-polarization.state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class RfPolarizationEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.rfPolarization.get),
			withLatestFrom(this.store.select(MpCommonSelectors.rfPolarization)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.rfPolarization.getSuccess(state))
					: of(MpCommonActions.rfPolarization.getApi())
			)
		)
	);

	api = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.rfPolarization.getApi),
			switchMap(() =>
				this.mpCommonService.rfPolarization().pipe(
					map((rfPolarization) =>
						MpCommonActions.rfPolarization.getSuccess({
							rfPolarization,
							loading: false
						})
					),
					catchError((error) =>
						of(MpCommonActions.rfPolarization.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private mpCommonService: MpCommonService
	) {}

	private canUseStoreValue(state: RfPolarizationState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
